export default __webpack_public_path__ + "static/media/Initiate's Cowl of the Moon.2e38ba9a.jpg";